import TreatmentInterview from './TreatmentInterview';
import TreatmentGuidanceInterview from './TreatmentGuidance';
import DynamicInterviewContainer from './DynamicInterview';
import TxocInterview from './TxocInterview';
import { withPolarisContext } from './PolarisContextProvider';
import { IMiniInterviewProps } from 'src/packages/polaris/types/interviews';
import PxocInterview from './PXOCInterview';

const MiniInterviewSelector = (props: IMiniInterviewProps) => {
  switch (props.interviewType) {
    case 'treatment':
      return <TreatmentInterview {...props} />;
    case 'treatmentGuidance':
      return <TreatmentGuidanceInterview {...props} />;
    case 'txoc':
      return <TxocInterview {...props} />;
    case 'pxoc':
      return <PxocInterview {...props} />;
    default:
      return <DynamicInterviewContainer {...props} />;
  }
};
export default withPolarisContext(MiniInterviewSelector);
